export default{
    preview: {},
    loading: false,
    error: ""
}